
export default function MyStory() {
  return (
    <section className="py-20 bg-gradient-to-b from-white to-rose-50/50">
      <div className="container mx-auto px-6 lg:px-12 max-w-4xl">
        {/* Titre */}
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 bg-rose-100 text-rose-600 text-sm font-medium rounded-full mb-4">
            Mon Histoire
          </span>
          <h2 className="text-3xl lg:text-4xl font-light text-gray-900 mb-4">
            Pourquoi j'ai créé cette boutique
          </h2>
          <div className="w-20 h-0.5 bg-rose-300 mx-auto"></div>
        </div>

        {/* Histoire */}
        <div className="bg-white rounded-3xl shadow-xl p-8 lg:p-12 border border-rose-100">
          <div className="prose prose-lg max-w-none text-gray-700 leading-relaxed space-y-6">
            <p className="text-xl font-medium text-gray-900 italic border-l-4 border-rose-300 pl-6">
              "Après des années de recherche, j'ai enfin trouvé une routine de soin qui donne de vrais résultats. Aujourd'hui, je la partage avec vous."
            </p>

            <p>
              Bienvenue sur ma boutique ! Si vous êtes ici, c'est que comme moi, vous avez probablement passé des années à chercher <strong>LA</strong> routine skincare qui fonctionne vraiment.
            </p>

            <p>
              Mon histoire avec ma peau a commencé à l'adolescence. Une période difficile qui m'a laissé des <strong>pores dilatés</strong>, une peau extrêmement inconfortable, et surtout, une perte de confiance en moi. J'ai souffert de ma peau pendant des années, essayant tout ce qui me passait sous la main.
            </p>

            <p>
              J'ai testé et retesté un nombre incalculable de produits : crèmes de pharmacie, soins de grandes surfaces, marques de luxe... Rien ne fonctionnait vraiment. À chaque fois, c'était la même déception. Je savais au fond de moi que si un jour je trouvais enfin <strong>les pépites</strong> qui changeraient tout, je les partagerais avec toutes celles qui vivent la même chose que moi.
            </p>

            <div className="bg-rose-50 rounded-2xl p-6 my-8">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-rose-200 rounded-full flex-shrink-0">
                  <i className="ri-heart-3-line text-2xl text-rose-600"></i>
                </div>
                <p className="text-gray-800 m-0">
                  <strong>Et ce jour est arrivé.</strong> Après avoir travaillé des jours et des nuits à rechercher, comparer et tester, j'ai déniché pour vous les <strong>meilleures pépites venues tout droit de Corée du Sud</strong> – le pays reconnu mondialement pour son expertise en skincare.
                </p>
              </div>
            </div>

            <p>
              Ces produits ont transformé ma peau. Ils m'ont redonné confiance. Et maintenant, je veux qu'ils fassent la même chose pour vous.
            </p>

            <p>
              Chaque produit que vous trouverez ici a été <strong>personnellement sélectionné et testé</strong> par mes soins. Je ne vous propose que ce qui fonctionne vraiment, ce qui a fait ses preuves sur ma propre peau.
            </p>

            <p className="text-center text-xl font-medium text-rose-600 pt-4">
              Bienvenue dans cette aventure skincare. Votre peau mérite le meilleur. 🌸
            </p>
          </div>

          {/* Signature */}
          <div className="flex items-center gap-6 mt-8">
            <div className="relative">
              <div className="w-20 h-20 rounded-full bg-gradient-to-br from-rose-100 to-pink-100 flex items-center justify-center">
                <i className="ri-heart-3-fill text-3xl text-rose-500"></i>
              </div>
            </div>
            <div>
              <p className="font-semibold text-gray-900">Avec tout mon amour,</p>
              <p className="text-rose-500 text-sm">Votre experte skincare coréen</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
